import axios from 'axios';
import { MESSAGES_API_PATH } from 'constants/constants';

export async function sendLiscioMessage(
  payload: SendLiscioMessagePayload,
): Promise<SendLiscioMessageResponse> {
  let response;
  if (payload.id && payload.id !== '') {
    response = await axios.patch(`${MESSAGES_API_PATH}/${payload.id}`, payload);
  }
  else {
    response = await axios.post(MESSAGES_API_PATH, payload);
  }
  return response.data;
}
